import React from 'react';

import Bing from './svgs/bing.inline.svg';
import Facebook from './svgs/facebook.inline.svg';
import Friends from './svgs/friends.inline.svg';
import Google from './svgs/google.inline.svg';
import Home from './svgs/home.inline.svg';
import Instagram from './svgs/instagram.inline.svg';
import LinkedIn from './svgs/linkedin.inline.svg';
import Podcast from './svgs/podcast.inline.svg';
import Reddit from './svgs/reddit.inline.svg';
import Spotify from './svgs/spotify.inline.svg';
import Tiktok from './svgs/tiktok.inline.svg';
import X from './svgs/x.inline.svg';
import Yelp from './svgs/yelp.inline.svg';
import Youtube from './svgs/youtube.inline.svg';

export type SurveyOption = {
	text: string
	icon: React.ReactNode
}

export const surveyOptions: SurveyOption[] = [
	{
		text: 'YouTube',
		icon: <Youtube />
	},
	{
		text: 'Google',
		icon: <Google />
	},
	{
		text: 'X',
		icon: <X />
	},
	{
		text: 'Facebook',
		icon: <Facebook />
	},
	{
		text: 'Instagram',
		icon: <Instagram />
	},
	{
		text: 'TikTok',
		icon: <Tiktok />
	},
	{
		text: 'Yelp',
		icon: <Yelp />
	},
	{
		text: 'Gym or work',
		icon: <Home />
	},
	{
		text: 'A podcast',
		icon: <Podcast />
	},
	{
		text: 'A friend',
		icon: <Friends />
	},
	{
		text: 'Spotify',
		icon: <Spotify />
	},
	{
		text: 'LinkedIn',
		icon: <LinkedIn />
	},
	{
		text: 'Reddit',
		icon: <Reddit />
	},
	{
		text: 'Bing',
		icon: <Bing />
	},

];
